import { render, staticRenderFns } from "./editUniversal.vue?vue&type=template&id=38a985e8"
import script from "./editUniversal.vue?vue&type=script&lang=js"
export * from "./editUniversal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports